import React, { Component } from "react";
import axios from "axios";
import { euro } from "../../../utils/priceFormatter";
import ReactTable from "react-table";
import { ratesValidator } from "../utils/ratesVailidator";

import { Button as ReactButton } from "reactstrap";
import { Switch, Modal, Button, message, Tooltip } from "antd";
import RatesDrawer from "../components/RatesDrawer";
import DropdownBtn from "../components/DropdownBtn";

class Rates extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      current_uuid: "",
      current_section: "",
      openAlert: false,
      openModal: false,
      isNewRate: false,
      rate: {
        uuid: "",
        title: "",
        description: "",
        price: "",
        section: "",
        status: false,
        discounts: [],
        delete_discounts: [],
      },
      formErrors: {},
    };

    this.getAllPhones = this.getAllPhones.bind(this);
    this.getAllInternet = this.getAllInternet.bind(this);
    this.handleEditForm = this.handleEditForm.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.getAllTelevision = this.getAllTelevision.bind(this);
    this.handleCancelForm = this.handleCancelForm.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleAddDiscount = this.handleAddDiscount.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleToggleStatus = this.handleToggleStatus.bind(this);
    this.handleDeleteProduct = this.handleDeleteProduct.bind(this);
    this.handleChangeDiscount = this.handleChangeDiscount.bind(this);
    this.handleRemoveDiscount = this.handleRemoveDiscount.bind(this);
    this.handleInternetSelected = this.handleInternetSelected.bind(this);
  }

  async componentDidMount() {
    const phones = await this.getAllPhones();
    const television = await this.getAllTelevision();
    const internet = await this.getAllInternet();

    this.setState({
      options: [...phones, ...television, ...internet],
    });
  }
  async refetchRatesState() {
    const phones = await this.getAllPhones();
    const television = await this.getAllTelevision();
    const internet = await this.getAllInternet();

    this.setState({
      options: [...phones, ...television, ...internet],
    });
  }
  async getAllPhones() {
    const res = await axios.post("https://dev.nadu.xyz/dev/admin/getPhones");
    if (res.data) {
      return res.data.map((option) => {
        return {
          uuid: option.uuid,
          status: (
            <Switch
              checked={option.status}
              onChange={() => this.handleToggleStatus(option.uuid, "phone")}
            />
          ),
          title: option.title,
          description: option.description,
          number_price: option.price,
          price: euro.format(option.price),
          section: "phone",
          discounts: option.discounts,
          section_icon: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
              }}
            >
              <Tooltip placement="bottom" title="Móvil" color={"#46b98a"}>
                <i
                  className="now-ui-icons tech_mobile"
                  style={{ fontSize: "20px" }}
                />
              </Tooltip>
            </div>
          ),
          actions: (
            <DropdownBtn
              section={option}
              handleEditSection={() => this.handleOpenModal(false, option.uuid)}
              handleDelete={() =>
                this.setState({
                  openAlert: true,
                  current_uuid: option.uuid,
                  current_section: "phone",
                })
              }
            />
          ),
        };
      });
    }
  }
  async getAllTelevision() {
    const res = await axios.post("https://dev.nadu.xyz/dev/admin/getTelevision");
    if (typeof res !== "undefined") {
      return res.data.map((option) => {
        return {
          uuid: option.uuid,
          status: (
            <Switch
              checked={option.status}
              onChange={() =>
                this.handleToggleStatus(option.uuid, "television")
              }
            />
          ),
          title: option.title,
          description: option.description,
          number_price: option.price,
          price: euro.format(option.price),
          section: "television",
          discounts: option.discounts,
          section_icon: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
              }}
            >
              <Tooltip placement="bottom" title="Televisión" color={"#46b98a"}>
                <i
                  className="now-ui-icons tech_tv"
                  style={{ fontSize: "20px" }}
                />
              </Tooltip>
            </div>
          ),
          actions: (
            <DropdownBtn
              section={option}
              handleEditSection={() => this.handleOpenModal(false, option.uuid)}
              handleDelete={() =>
                this.setState({
                  openAlert: true,
                  current_uuid: option.uuid,
                  current_section: "television",
                })
              }
            />
          ),
        };
      });
    }
  }
  async getAllInternet() {
    const res = await axios.post("https://dev.nadu.xyz/dev/admin/getInternet");
    if (typeof res !== "undefined") {
      return res.data.map((option) => {
        return {
          uuid: option.uuid,
          status: (
            <Switch
              checked={option.status}
              onChange={() => this.handleToggleStatus(option.uuid, "internet")}
            />
          ),
          title: option.title,
          description: option.description,
          number_price: option.price,
          price: euro.format(option.price),
          section: "internet",
          section_icon: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
              }}
            >
              <Tooltip placement="bottom" title="Internet" color={"#46b98a"}>
                <i
                  className="now-ui-icons business_globe"
                  style={{ fontSize: "20px" }}
                />
              </Tooltip>
            </div>
          ),
          actions: (
            <DropdownBtn
              section={option}
              handleEditSection={() => this.handleOpenModal(false, option.uuid)}
              handleDelete={() =>
                this.setState({
                  openAlert: true,
                  current_uuid: option.uuid,
                  current_section: "internet",
                })
              }
            />
          ),
        };
      });
    }
  }
  handleOpenModal(isNew = false, uuid) {
    if (isNew) {
      this.setState({
        openModal: true,
        isNewRate: isNew,
        rate: {
          title: "",
          description: "",
          price: "",
          status: false,
          section: "phone",
          discounts: [],
          delete_discounts: [],
        },
      });
    } else {
      const selectedOption = this.state.options.find(
        (elem) => elem.uuid === uuid
      );
      this.setState({
        openModal: true,
        isNewRate: false,
        rate: {
          uuid: selectedOption.uuid,
          title: selectedOption.title,
          description: selectedOption.description,
          price: selectedOption.number_price,
          status: selectedOption.status.props.checked,
          section: selectedOption.section,
          discounts: selectedOption.discounts,
          delete_discounts: [],
        },
      });
    }
  }
  handleCancelForm() {
    this.setState({
      openModal: false,
      isNewRate: false,
      rate: {
        title: "",
        description: "",
        price: "",
        status: false,
        section: "",
        discounts: [],
      },
      formErrors: {},
    });
  }
  validateAndSetErrors() {
    const { rate } = this.state;
    const errors = ratesValidator(rate);
    this.setState({ formErrors: errors });
  }
  handleInputChange(event) {
    if (typeof event === "string") {
      this.setState(
        {
          rate: {
            ...this.state.rate,
            section: event,
            internet_type: "fibraNadunet",
          },
        },
        () => this.validateAndSetErrors()
      );
    } else if (typeof event === "boolean") {
      this.setState(
        {
          rate: {
            ...this.state.rate,
            status: event,
          },
        },
        () => this.validateAndSetErrors()
      );
    } else {
      const { name, value } = event.target;
      let newPrice;
      if (name === "price") {
        const regex = /^(\d+(\.\d*)?|\.\d+)?$/;
        const normalizedValue = value.replace(",", ".");
        newPrice = regex.test(normalizedValue)
          ? normalizedValue
          : this.state.rate.price;
      }
      this.setState(
        {
          rate: {
            ...this.state.rate,
            [name]: name === "price" ? newPrice : value,
          },
        },
        () => this.validateAndSetErrors()
      );
    }
  }
  handleInternetSelected(internet_type) {
    this.setState({
      rate: { ...this.state.rate, internet_type: internet_type },
    });
  }
  handleFormSubmit(section) {
    let query;
    let formattedBody;
    if (section === "internet") {
      query = "createInternet";
      formattedBody = {
        title: this.state.rate.title,
        subtitle: this.state.rate.description,
        price: Number(this.state.rate.price).toFixed(2),
        ref_service: this.state.rate.section,
        internet_type: this.state.rate.internet_type,
        status: this.state.rate.status,
        discounts: this.state.rate.discounts,
      };
    } else {
      query = section === "phone" ? "createPhone" : "createTelevision";
      formattedBody = {
        title: this.state.rate.title,
        subtitle: this.state.rate.description,
        price: Number(this.state.rate.price).toFixed(2),
        ref_service: this.state.rate.section,
        status: this.state.rate.status,
        discounts: this.state.rate.discounts,
      };
    }
    axios
      .post(`https://dev.nadu.xyz/dev/admin/${query}`, {
        params: formattedBody,
      })
      .then((res) => {
        if (res.data.ok) {
          message.success(res.data.message);
          this.refetchRatesState();
          this.setState({
            openModal: false,
            isNewService: false,
            rate: {
              title: "",
              description: "",
              price: "",
              section: "phone",
              status: false,
              discounts: [],
            },
            formErrors: {},
          });
        } else {
          message.error(res.data.error);
        }
      })
      .catch((error) => console.error("Error en la solicitud POST:", error));
  }
  handleEditForm(section) {
    let query;
    let formattedBody;
    if (section === "internet") {
      query = "updateInternet";
      formattedBody = {
        title: this.state.rate.title,
        subtitle: this.state.rate.description,
        price: Number(this.state.rate.price).toFixed(2),
        ref_service: this.state.rate.section,
        internet_type: this.state.rate.internet_type,
        status: this.state.rate.status,
        discounts: this.state.rate.discounts,
        delete_discounts: this.state.rate.delete_discounts,
      };
    } else {
      query = section === "phone" ? "updatePhone" : "updateTelevision";
      formattedBody = {
        title: this.state.rate.title,
        subtitle: this.state.rate.description,
        price: Number(this.state.rate.price).toFixed(2),
        ref_service: this.state.rate.section,
        status: this.state.rate.status,
        discounts: this.state.rate.discounts,
        delete_discounts: this.state.rate.delete_discounts,
      };
    }
    axios
      .post(`https://dev.nadu.xyz/dev/admin/${query}`, {
        params: {
          node_id: this.state.rate.uuid,
          fields: formattedBody,
        },
      })
      .then((res) => {
        if (res.data.ok) {
          message.success(res.data.message);
          this.refetchRatesState();
          this.setState({
            openModal: false,
            isNewService: false,
            rate: {
              title: "",
              description: "",
              price: "",
              section: "phone",
              status: false,
              discounts: [],
              delete_discounts: [],
            },
            formErrors: {},
          });
        } else {
          message.error(res.data.error);
        }
      })
      .catch((error) => console.error("Error en la solicitud POST:", error));
  }
  handleDeleteProduct(uuid, section) {
    if (section === "phone") {
      axios
        .post("https://dev.nadu.xyz/dev/admin/deletePhone", { params: uuid })
        .then((response) => {
          this.refetchRatesState();
        })
        .catch((error) => console.error("Error en la solicitud POST:", error));
    } else if (section === "internet") {
      axios
        .post("https://dev.nadu.xyz/dev/admin/deleteInternet", { params: uuid })
        .then((response) => {
          this.refetchRatesState();
        })
        .catch((error) => console.error("Error en la solicitud POST:", error));
    } else {
      axios
        .post("https://dev.nadu.xyz/dev/admin/deleteTelevision", {
          params: uuid,
        })
        .then((response) => {
          this.refetchRatesState();
        })
        .catch((error) => console.error("Error en la solicitud POST:", error));
    }
  }
  handleToggleStatus(uuid, section) {
    axios
      .post(`https://dev.nadu.xyz/dev/admin/${section}Status`, { params: uuid })
      .then((res) => {
        if (res.data.ok) {
          message.success(res.data.message);
          const allOptions = [...this.state.options].map((option) => {
            if (
              option.uuid === uuid &&
              res.data.newStatus === !option.status.props.checked
            ) {
              const newObj = {
                ...option,
                status: {
                  ...option.status,
                  props: {
                    ...option.status.props,
                    checked: res.data.newStatus,
                  },
                },
              };
              return newObj;
            } else return option;
          });

          this.setState({
            options: allOptions,
          });
        } else {
          message.error(res.data.message);
        }
      })
      .catch(() => message.error("Hubo un error al actualizar el estado."));
  }
  handleChangeDiscount(index, section, newValue) {
    const updatedDiscounts = [...this.state.rate.discounts].map(
      (discount, idx) => {
        if (idx === index) {
          let newPrice;
          if (section === "discount_amount") {
            const regex = /^(\d+(\.\d*)?|\.\d+)?$/;
            const normalizedValue = newValue.replace(",", ".");
            newPrice = regex.test(normalizedValue)
              ? normalizedValue
              : this.state.rate.discounts[idx].discount_amount;
          }
          return {
            ...discount,
            [section]: section === "discount_amount" ? newPrice : newValue,
          };
        } else return discount;
      }
    );
    this.setState(
      {
        rate: {
          ...this.state.rate,
          discounts: updatedDiscounts,
        },
      },
      () => this.validateAndSetErrors()
    );
  }
  handleAddDiscount(add) {
    this.setState(
      {
        rate: {
          ...this.state.rate,
          discounts: [
            ...this.state.rate.discounts,
            {
              internet_id: undefined,
              discount_type: undefined,
              discount_amount: "",
            },
          ],
        },
      },
      () => this.validateAndSetErrors()
    );
    add();
  }
  handleRemoveDiscount(index) {
    const discountToRemove = [...this.state.rate.discounts][index];
    const newDiscounts = [...this.state.rate.discounts].filter(
      (_, idx) => idx !== index
    );

    this.setState(
      {
        rate: {
          ...this.state.rate,
          discounts: newDiscounts,
          delete_discounts: [
            ...this.state.rate.delete_discounts,
            discountToRemove.id,
          ],
        },
      },
      () => this.validateAndSetErrors()
    );
  }
  render() {
    return (
      <div>
        <div
          style={{
            marginTop: "10px",
            display: "flex",
            flexDirection: "column",
            alignItems: "end",
            justifyContent: "center",
          }}
        >
          <ReactButton
            style={{ width: "fit-content" }}
            onClick={() => this.handleOpenModal(true)}
          >
            Añadir Servicio
          </ReactButton>
          <ReactTable
            style={{ width: "100%" }}
            columns={[
              {
                Header: "Sección",
                accessor: "section_icon",
                sortable: false,
                filterable: false,
              },
              {
                Header: "Titulo",
                accessor: "title",
              },

              {
                Header: "Precio",
                accessor: "price",
                filterable: false,
              },
              {
                Header: "Status",
                accessor: "status",
                filterable: false,
              },
              {
                Header: "Actions",
                accessor: "actions",
                sortable: false,
                filterable: false,
              },
            ]}
            data={this.state.options}
            filterable
            defaultPageSize={10}
            className="-striped -highlight"
          />
        </div>
        <RatesDrawer
          rate={this.state.rate}
          isNewRate={this.state.isNewRate}
          openModal={this.state.openModal}
          formErrors={this.state.formErrors}
          handleEditForm={this.handleEditForm}
          handleFormSubmit={this.handleFormSubmit}
          handleCancelForm={this.handleCancelForm}
          handleInputChange={this.handleInputChange}
          handleAddDiscount={this.handleAddDiscount}
          handleChangeDiscount={this.handleChangeDiscount}
          handleRemoveDiscount={this.handleRemoveDiscount}
          handleInternetSelected={this.handleInternetSelected}
        />
        <Modal
          open={this.state.openAlert}
          title="Eliminar elemento"
          closeIcon={false}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            gap: "15px",
          }}
          footer={() => (
            <div style={{ display: "flex", gap: "6px" }}>
              <Button onClick={() => this.setState({ openAlert: false })}>
                Cancelar
              </Button>
              <Button
                onClick={() => {
                  this.handleDeleteProduct(
                    this.state.current_uuid,
                    this.state.current_section
                  );
                  this.setState({ openAlert: false });
                }}
                type="primary"
                danger={true}
              >
                Eliminar
              </Button>
            </div>
          )}
        >
          ¿Deseas eliminar el elemento?
        </Modal>
      </div>
    );
  }
}

export default Rates;



// WEBPACK FOOTER //
// ./src/views/Configurator/Tabs/Rates.jsx